import React, { useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import strings from "../Globalization/index";
import QuickSerchSocpeTable from '../AppGrid/QuickSerchSocpeTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import catAdminUtils from '../util/catAdminUtils';
import consts from '../consts';
import connectionService from '../services/Connection';

export const QuickSearchScope = () => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const breadcrumbsArrLength = breadcrumbs.breadcrumbs?.length
	const navigate = useNavigate();
	const BackButton = () => {
		return (<Button variant='contained' startIcon={<ArrowBackIcon />} onClick={() => { navigate('/endoSetup') }}>{strings.Back}</Button>)
	}
	useEffect(() => {
		if (breadcrumbsArrLength < 2) {
			setBreadcrumbs({
				docTitle: strings.QuickSearchScope, breadcrumbs: [{ text: strings.QuickSearchScope }],
				actions: [{ component: BackButton }]
			});
		}
	}, [breadcrumbsArrLength]);


	return (
		<Grid container>
			<Grid size={12}>
				<QuickSerchSocpeTable onSubmit={(values, { activeRecord, ...param }) => catAdminUtils.handleOnSubmit({
					values,
					activeRecord,
					maxCount: consts.maxScopesCount,
					message: strings.ScopesCountWarning,
					apiUrl: connectionService.HuluScope,
					navigate,
					navigateUrl: "/quicksearchscope",
					...param
				})} />
			</Grid>
		</Grid>
	);
}

